import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@app/core/validators/custom.validators';
import { AuthService } from '@auth/state/auth.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  @Output() onSave = new EventEmitter<string>();
  @Output() onClose = new EventEmitter<any>();

  form!: FormGroup;
  submitted = false
  showingDialog!: boolean;
  error = '';

  get password() { return this.form.get('password'); }
  get newPassword() { return this.form.get('newPassword'); }
  get confirmPassword() { return this.form.get('confirmPassword'); }


  constructor(
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService
  ) { }

  ngOnInit(): void {
    this.showingDialog = true;

    this.form = this.formBuilder.group({
      password: ['', [ Validators.required, Validators.minLength(6) ] ],
      newPassword: ['', [ Validators.required, Validators.minLength(6) ] ],
      confirmPassword: ['', [ Validators.required, Validators.minLength(6)] ]      
    },
    {
      validators: [ CustomValidators.changeMustMatch ]
    })
  }

  stopEvent( event: MouseEvent ) {
    event.stopPropagation()
  }

  onCloseModal() {
    this.showingDialog = false;
    this.onClose.emit();
  }

  onSubmit() {
    this.submitted = true;
    if( this.form.invalid ) return;

    this.error = '';

    this.authService.passwordChange( this.form.value ).subscribe( 
      response => {
        this.showingDialog = false;
        this.authService.logout();
        // redirect to login
        this.router.navigateByUrl('/auth/login')
        console.log(response);
      },

      err => {
          this.error = err.error.message;
      }

    )


  //  this.showingDialog = false;
  //  this.onSave.emit( this.form.value )
  }

}
